export class ListNotificationPoliciesResponse {
    'notificationPolicies';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "notificationPolicies",
            "baseName": "notificationPolicies",
            "type": "Array<NotificationPolicy>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListNotificationPoliciesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
